import {
  whiteColor,
  blackColor,
  warningColor,
  activeLinkColor,
} from '../../../common/assets/jss/appStyle';

export default theme => ({
  mainGrid: {
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    alignItems: 'stretch',
    overFlowX: 'scroll',
  },
  formContainer: {
    backgroundColor: whiteColor,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '100vh',
    boxSizing: 'border-box',
    padding: '2rem',
    overFlow: 'auto',
    gap: 60,
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '100vh',
    boxSizing: 'border-box',
    background:
      'linear-gradient(180deg, #0099FF 0%, #6EC5FF 50%, #C9E9FF 100%)',
    textAlign: 'center',
    padding: '2rem',
  },
  logoTextDecoration: {
    color: whiteColor,
    fontSize: '4em',
    fontWeight: 'bold',
  },
  descriptionTextDecoration: {
    color: whiteColor,
    fontSize: '2em',
    fontWeight: '500',
  },
  logoImage: {
    width: 'auto',
    maxWidth: '150px',
    maxHeight: '5rem',
    marginTop: '1em',
  },
  mainContentWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  titleBox: {
    width: '75%',
    textAlign: 'start',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  form: {
    width: '75%',
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  inputsLabel: {
    color: blackColor,
    marginBottom: '0.25em',
    display: 'block',
  },
  formTextInput: {
    width: '100%',
  },
  submit: {
    width: '100%',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
  hyperLink: {
    color: '#00406B',
    '&:hover': {
      cursor: 'pointer',
    },
    fontSize: '0.875rem',
    textAlign: 'end',
    display: 'block',
    fontWeight: 'bold',
  },
  qrButtonWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  qrLoginButton: {
    display: 'flex',
    gap: 8,
    backgroundColor: '#F2FAFF',
    alignItems: 'center',
    color: '#0099FF',
    boxShadow: 'none',
    width: '75%',
    justifyContent: 'center',
    paddingTop: theme.spacing(1.25),
    paddingBottom: theme.spacing(1.25),
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
    '&:hover': {
      backgroundColor: '#E0F4FF',
      boxShadow: 'none',
    },
    '&:focus': {
      boxShadow: 'none',
    },
  },
  descriptionQrButton: {
    fontSize: '0.95rem',
    fontWeight: 500,
  },
  descriptionColor: {
    color: blackColor,
  },
  warning: {
    background: warningColor,
    borderRadius: 8,
    padding: 5,
    margin: 5,
    width: '75%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    color: whiteColor,
    gap: 5,
  },
  activeLink: {
    color: activeLinkColor,
  },
  tempImage: {
    margin: '24px 0 24px 0px;',
  },
});
